import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = (route.data['roles'] as string[] | undefined) ?? [];
  const userRoles = authService.currentUser()?.roles ?? [];

  return requiredRoles.length === 0 || requiredRoles.some((role) => userRoles.includes(role))
    ? true
    : router.parseUrl('/no-autorizado');
};
